import { useLocation } from '@redwoodjs/router'

import { useAuth } from 'src/auth'

/**
 * Team users: `/packning` (no query). Admins: `/admin/packning?...&sellingPeriodId=`.
 */
export function usePackagingGuideAccess() {
  const { hasRole } = useAuth()
  const { search } = useLocation()
  const sellingPeriodId =
    new URLSearchParams(search).get('sellingPeriodId') || undefined

  const isTeamUser = hasRole('lead') || hasRole('member')
  const isAdminWithPeriod = hasRole('admin') && !!sellingPeriodId
  const canUsePackningGuide = isTeamUser || isAdminWithPeriod

  return {
    sellingPeriodId,
    canUsePackningGuide,
    packagingGuideQueryVariables: sellingPeriodId
      ? { sellingPeriodId }
      : {},
  }
}
